// Generated by Melange

import * as Stdlib__Int from "melange/int.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Subsonic__Utils from "./utils.jsx";

function makeUrl(credentials, coverArt, size, param) {
  const params = {};
  params["id"] = {
    TAG: /* Value */ 1,
    _0: coverArt
  };
  Stdlib__Option.iter((function (size) {
    params["size"] = {
      TAG: /* Value */ 1,
      _0: Stdlib__Int.to_string(size)
    };
  }), size);
  return Subsonic__Utils.buildSubsonicApiUrl(credentials, {
    _method: "rest/getCoverArt",
    params: params
  }).href;
}

export {
  makeUrl,
}
/* No side effect */
